
import { AppModule } from './app/app.module';
import { enableProdMode } from '@angular/core';
import { ENVIRONMENT } from './environments/environment';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import 'zone.js';

if (ENVIRONMENT.PRODUCTION) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.log(err));
